export default function filterHostNameForApi(hostname) {
    return hostname.replace('local.', 'staging.').replace('dev.', 'staging.');
}
